
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.64 6.087l1.303-1.417h-2.89A8.97 8.97 0 007.97 3.106 8.95 8.95 0 002.897 4.67H0l1.303 1.417a3.983 3.983 0 105.391 5.864l1.276 1.39 1.277-1.389a3.985 3.985 0 105.392-5.865zm-10.653 5.64a2.695 2.695 0 110-5.39 2.695 2.695 0 010 5.39zm3.984-2.774c0-1.772-1.29-3.296-2.992-3.946a7.733 7.733 0 012.992-.598 7.74 7.74 0 012.992.598c-1.7.65-2.992 2.172-2.992 3.946zm3.982 2.773a2.695 2.695 0 110-5.388 2.695 2.695 0 010 5.388zm0-4.108a1.412 1.412 0 100 2.824 1.412 1.412 0 000-2.824zM5.4 9.03a1.413 1.413 0 11-2.826.001 1.413 1.413 0 012.826 0z"}})])
          )
        }
      }
    